import { TIntegracaoCampoModel } from "../../../@types/IntegracaoCampoModel";

export enum ESelectFieldInitializationStrategy {
  Empresas = "empresas",
  FornecedoresConfiaveis = "fornecedoresConfiaveis",
  Endpoint = "endpoint",
  StaticOptions = "staticOptions",
  DeferredEndpoint = "deferredEndpoint"
}

export const resolveSelectFieldInitializationStrategy = (
  campo: Pick<TIntegracaoCampoModel, "endpoint" | "nomeObjetoNoLegado">,
  hasEndpointParameters: boolean,
  isCampoEmpresas: boolean
): ESelectFieldInitializationStrategy => {
  if (isCampoEmpresas && !campo.endpoint) {
    return ESelectFieldInitializationStrategy.Empresas;
  }

  if (campo.nomeObjetoNoLegado === "FornecedoresConfiaveis") {
    return ESelectFieldInitializationStrategy.FornecedoresConfiaveis;
  }

  if (campo.endpoint && !hasEndpointParameters) {
    return ESelectFieldInitializationStrategy.Endpoint;
  }

  if (!campo.endpoint) {
    return ESelectFieldInitializationStrategy.StaticOptions;
  }

  return ESelectFieldInitializationStrategy.DeferredEndpoint;
};
